import {
  SideFormFooter,
  SideFormContent,
  SideForm,
  SideMenuFormFooterBase,
} from "../../Components/Forms/SideMenuForm";
import {
  BaseSidebarContainer,
  BaseSidebarHeader,
  BaseSidebarContent,
  useSidebarSpaceDelete,
  useSidebarSpacePost,
} from "../../Components/Sidebar/SidebarV2Helper";
import { FormattedMessage, useIntl } from "react-intl";
import { handleError } from "../../Helpers/MiscHelper";
import { spaceAgendaSchema } from "../../config/schema";
import { useToast } from "../../Components/Toast/ToastProvider";
import { useFormState, createFormRequestHook } from "../../Components/Forms";
import LoaderSpinner from "../../Components/Loader/LoaderSpinner/LoaderSpinner";
import { useAgenda, useOutlookEvent } from "../../Hooks/EntityHooks";
import FormInput from "../../Components/Forms/FormInput/FormInput";
import ArDatePicker from "../../Components/DatePicker/ArDatePicker";
import DocTyper from "../../Components/DocTyper/DocTyper";
import { useMemo, useEffect, useRef, useCallback } from "react";
import Button from "../../Components/Button/Button";
import { useEntitySummarySidebar } from "../../Components/EntitySummaries/EntitySummariesHelper";
import { moduleTypes } from "../../Helpers/ModulesHelper";
import MinuteInput from "../../Components/Input/MinuteInput";
import LoadableButton from "../../Components/Button/LoadableButton";
import CreatedBy from "../../Components/CreatedByComponent/CreatedBy";
import { useCurrentAccount } from "../../Contexts/UserContext";
import UpdatedBy from "../../Components/CreatedByComponent/UpdatedBy";
import dayjs from "dayjs";
export const convertEntityToForm = (entity) => {
  return {
    ...entity,
  };
};

const useAgendaRequest = createFormRequestHook({
  schema: spaceAgendaSchema,
  convertEntityToForm: convertEntityToForm,
});

const AgendaForm = ({ ...props }) => {
  const { viewOutlookEvent } = props;

  if (!viewOutlookEvent) {
    return <AgendaFormInner {...props} />;
  }

  return <OutlookEventForm {...props} />;
};

const OutlookEventForm = ({ ...props }) => {
  const { id, refetchCalendar, personalPreferences } = props;
  const event = useOutlookEvent(id);
  const { Subject } = event || {};

  const formState = useFormState(() => {
    const { BeginDate, Content, EndDate } = event || {};

    return {
      BeginDate,
      EndDate,
      Description: Subject + " \n\r" + Content,
      TotalPauses: 0,
    };
  });

  const { form } = formState;
  const { BeginDate, EndDate, Description, TotalPauses } = form;

  const canCreateIntervention = useMemo(() => {
    const today = dayjs();
    const compare = dayjs(BeginDate);

    return (
      dayjs(today).isAfter(compare, "day") ||
      dayjs(today).isSame(compare, "day")
    );
  }, [BeginDate]);

  const validateCancelForm = ({ BeginDate, Description }, addError) => {
    if (!BeginDate) addError("BeginDate");
    if (!Description) addError("Description");
  };

  return (
    <BaseSidebarContainer>
      <BaseSidebarHeader>
        <FormattedMessage id={"OUTLOOK_EVENT"} />
      </BaseSidebarHeader>
      <BaseSidebarContent>
        <SideForm
          canEdit={false}
          formState={formState}
          onSubmit={() => {}}
          validate={validateCancelForm}
        >
          <SideFormContent className="px-4 py-3">
            <FormInput
              className="mb-3"
              name="BeginDate"
              textId="DATE"
              // onChange={DateChange}
              inputType={ArDatePicker}
              componentClassName="w-100"
              enableDate
              showDateBar
              // disableFutureDays={!FutureDatesStatus}
              enableHours={false}
            />

            <div className="mb-3 w-100 d-flex gap-3">
              <FormInput
                // onChange={HourChange}
                name="BeginDate"
                textId="START"
                inputType={ArDatePicker}
                componentClassName="w-100"
                className="w-100"
                enableDate={false}
              />

              <FormInput
                name="EndDate"
                // onChange={HourChange}
                textId="END"
                inputType={ArDatePicker} //AdminCheckDatePicker
                componentClassName="w-100"
                className="w-100"
                enableDate={false}
              />
              {/* <FormInput
                name="TotalPauses"
                textId="TOTAL_PAUSES"
                inputType={MinuteInput}
                componentClassName="w-100"
                className="flex-0-0-auto"
              /> */}
            </div>

            <FormInput
              className="mb-3 outlookevents-full-height h-full h-100"
              name="Description"
              textId="DESCRIPTION"
              preview
              noToolbar
              onChange={undefined}
              inputType={DocTyper}
              DisabledmaximizeButton
            />
          </SideFormContent>
          <div className="py-3 px-4 shadow-top details-form-footer shadow-top">
            <SideFormFooter
              showFooterAnyway
              canDelete={false}
              hideSubmit={true}
            >
              <div className="d-flex justify-content-end">
                {canCreateIntervention ? (
                  <ConvertToTimeButton
                    showFooterAnyway
                    BeginDate={BeginDate}
                    EndDate={EndDate}
                    refetchCalendar={refetchCalendar}
                    personalPreferences={personalPreferences}
                    handleDelete={() => {}}
                    Description={Description}
                    TotalPauses={TotalPauses}
                  />
                ) : (
                  <div></div>
                )}
              </div>
            </SideFormFooter>
          </div>
        </SideForm>
      </BaseSidebarContent>
    </BaseSidebarContainer>
  );
};

const AgendaFormInner = ({ ...props }) => {
  const {
    id,
    onSuccess,
    defaultForm,
    duplicationForm,
    refetchCalendar,
    personalPreferences,
    selectedUser,
  } = props;

  const {
    // key,
    loading,
    error,
    convertedForm,
    // isChild,
    // childProps,
  } = useAgendaRequest(props);

  const agendaEntry = useAgenda(id);

  const resolvedForm = useMemo(() => {
    const form = {
      ...defaultForm,
      ...convertedForm,
      ...duplicationForm,
    };

    return form;
  }, [convertedForm, defaultForm, duplicationForm]);

  const canEdit = agendaEntry ? !agendaEntry.HasTime : true;
  if (loading || error)
    return (
      <BaseSidebarContainer defaultSidebarView={2}>
        <BaseSidebarHeader>
          <FormattedMessage id={"AGENDA_ENTRY"} />
        </BaseSidebarHeader>
        <BaseSidebarContent>
          <div className="d-flex h-100 w-100 justify-content-center align-items-center">
            <LoaderSpinner center size="sm" className="text-secondary" />
          </div>
        </BaseSidebarContent>
      </BaseSidebarContainer>
    );
  return (
    <Form
      onSuccess={onSuccess}
      id={id}
      canEdit={canEdit}
      selectedUser={selectedUser}
      personalPreferences={personalPreferences}
      convertedForm={resolvedForm}
      refetchCalendar={refetchCalendar}
      canDelete={Boolean(id)}
      {...props}
    />
  );
};

export const defaultForm = () => {
  return {
    Name: "",
    Enabled: true,
    Pipeline: [],
  };
};

const Form = ({
  convertedForm,
  id,
  selectedUser,
  canEdit,
  onSuccess,
  refetchCalendar,
  refetchRef,
  personalPreferences,
  isChild,
  canDelete,
  handleGoBackToOldView,
  FutureDatesStatus = true,
  ...props
}) => {
  const formState = useFormState(() => {
    return {
      ...defaultForm(),
      ...convertedForm,
    };
  });

  const { form, handleChange } = formState;
  const {
    BeginDate,
    EndDate,
    Account,
    Description,
    TotalPauses,
    WasDeleted,
    Creator,
    UpdateAt,
    Updater,
    CreateAt,
  } = form;

  const createToast = useToast();
  // const currentUser = useCurrentAccount();
  const intl = useIntl();
  const closingRef = useRef(false);
  const [post, { loading }] = useSidebarSpacePost(
    id ? `calendars/${selectedUser}/${id}` : `calendars/${selectedUser}`,
    spaceAgendaSchema,
    {
      onSuccess: ({ openSidebar, data: newId, defineChildProps }) => {
        closingRef.current = true;
        createToast({
          pos: "tm",
          type: "success",
          title: `${intl.formatMessage({ id: "AGENDA_ENTRY" })}`,
          description: intl.formatMessage({ id: "SUCCESS_SAVED" }),
        });
        onSuccess && onSuccess();
        refetchCalendar && refetchCalendar();
      },
      refetchRef,
      onError: ({ error }) => {
        handleError(createToast, error);
      },
    },
  );

  const [convert, { loading: convertLoading }] = useSidebarSpaceDelete(
    `calendars/${selectedUser}/2/${id}`,
    null,
    {
      onSuccess: ({ openSidebar, data: newId, defineChildProps }) => {
        refetchCalendar && refetchCalendar();
      },
      onError: ({ error }) => {
        if (error) handleError(error);
      },
      refetchRef,
    },
  );

  const [remove, { loading: deleteLoading }] = useSidebarSpaceDelete(
    `calendars/${selectedUser}/1/${id}`,
    null,
    {
      onSuccess: ({ openSidebar, data: newId, defineChildProps }) => {
        // createToast({
        //   pos: "tm",
        //   type: "success",
        //   title: `${intl.formatMessage({ id: "AGENDA_ENTRY" })}`,
        //   description: `${intl.formatMessage({ id: "SUCCESS_DELETED" })}`
        // });
        refetchCalendar && refetchCalendar();
      },
      onError: ({ error }) => {
        handleError(error);
      },
      refetchRef,
    },
  );

  const formatForm = (form) => {
    const { BeginDate, EndDate, Description, TotalPauses } = form;
    return {
      BeginDate: dayjs(BeginDate).format("YYYY-MM-DDTHH:mm:ssZ"),
      EndDate: dayjs(EndDate).format("YYYY-MM-DDTHH:mm:ssZ"),
      Description,
      TotalPauses,
    };
  };

  const DateChange = (e) => {
    const { value } = e.target;

    if (!(value instanceof Date && isFinite(value))) return;
    let date = new Date(value);
    const currentDate = new Date();
    if (
      Date.parse(date) > Date.parse(currentDate) &&
      FutureDatesStatus === false
    )
      date = new Date();
    const beginDate = new Date(BeginDate);
    const endDate = new Date(EndDate);

    endDate.setFullYear(date.getFullYear());
    endDate.setMonth(date.getMonth(), date.getDate());
    beginDate.setFullYear(date.getFullYear());
    beginDate.setMonth(date.getMonth(), date.getDate());

    handleChange({
      BeginDate: beginDate,
      EndDate: endDate,
    });
  };

  const HourChange = (e) => {
    const { name, value } = e.target;
    const tempDate = new Date(BeginDate);
    tempDate.setHours(value[0]);
    tempDate.setMinutes(value[1]);
    handleChange({
      [name]: tempDate,
    });
  };

  const handleSubmit = (form) => {
    if (!closingRef.current) post(formatForm(form));
  };

  const validateCancelForm = ({ BeginDate, Description }, addError) => {
    if (!BeginDate) addError("BeginDate");
    if (!Description) addError("Description");
  };

  const timeoutRef = useRef();
  const currentAccount = useCurrentAccount();

  const canConvert = useMemo(() => {
    const tomorow = dayjs().add(1, "day");
    if (Account) {
      const today = dayjs();
      const compare = dayjs(BeginDate);

      return (
        dayjs(today).isAfter(compare, "day") ||
        dayjs(today).isSame(compare, "day")
      );

      // return (
      //   Account === currentAccount.Id &&
      //   dayjs(BeginDate).isBefore(tomorow, "day")
      // );
    } else
      return (
        currentAccount.Id === selectedUser &&
        dayjs(BeginDate).isBefore(tomorow, "day")
      );
  }, [Account, BeginDate, currentAccount.Id, selectedUser]);

  const SubcompomentForConvert = useMemo(() => {
    return (
      <div className="d-flex justify-content-between w-100 flex-fill align-items-center">
        {canDelete ? (
          <DeleteButton remove={remove} loadingRemove={deleteLoading} />
        ) : (
          <></>
        )}
        {canConvert ? (
          <ConvertToTimeButton
            BeginDate={BeginDate}
            EndDate={EndDate}
            refetchCalendar={refetchCalendar}
            personalPreferences={personalPreferences}
            handleDelete={convert}
            Description={Description}
            TotalPauses={TotalPauses}
            entityId={id}
          />
        ) : (
          <></>
        )}
      </div>
    );
  }, [
    canDelete,
    remove,
    deleteLoading,
    canConvert,
    BeginDate,
    EndDate,
    refetchCalendar,
    personalPreferences,
    convert,
    Description,
    TotalPauses,
    id,
  ]);

  const SubcompomentForRecover = useMemo(() => {
    return (
      <RecoverButton
        refetchCalendar={refetchCalendar}
        selectedUser={selectedUser}
        entityId={id}
        refetchRef={refetchRef}
      />
    );
  }, [refetchCalendar, selectedUser, id, refetchRef]);

  useEffect(() => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      const el = document.querySelector(".ProseMirror");
      if (el) {
        el.focus(); // Works if it's contenteditable or has tabindex
      }
    }, 600);
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  useEffect(() => {
    return () => {
      handleGoBackToOldView && handleGoBackToOldView();
    };
  }, [handleGoBackToOldView]);

  return (
    <BaseSidebarContainer>
      <BaseSidebarHeader>
        <FormattedMessage
          id={id ? "UPDATE_AGENDA_ENTRY" : "CREATE_AGENDA_ENTRY"}
        />
      </BaseSidebarHeader>
      <BaseSidebarContent>
        <SideForm
          canEdit={!WasDeleted}
          formState={formState}
          onSubmit={handleSubmit}
          validate={validateCancelForm}
        >
          <SideFormContent className="px-4 py-3">
            <FormInput
              className="mb-3"
              name="BeginDate"
              textId="DATE"
              onChange={DateChange}
              inputType={ArDatePicker}
              componentClassName="w-100"
              enableDate
              showDateBar
              disableFutureDays={!FutureDatesStatus}
              enableHours={false}
            />

            <div className="mb-3 w-100 d-flex gap-3">
              <FormInput
                onChange={HourChange}
                name="BeginDate"
                textId="START"
                inputType={ArDatePicker}
                componentClassName="w-100"
                className="w-100"
                enableDate={false}
              />

              <FormInput
                name="EndDate"
                onChange={HourChange}
                textId="END"
                inputType={ArDatePicker} //AdminCheckDatePicker
                componentClassName="w-100"
                className="w-100"
                enableDate={false}
              />
              <FormInput
                name="TotalPauses"
                textId="TOTAL_PAUSES"
                inputType={MinuteInput}
                componentClassName="w-100"
                className="flex-0-0-auto"
              />
            </div>

            <FormInput
              className="mb-3"
              name="Description"
              textId="DESCRIPTION"
              inputType={DocTyper}
              DisabledmaximizeButton
            />
            {Creator ? (
              <CreatedBy Creator={Creator} CreationDate={CreateAt} />
            ) : (
              <></>
            )}
            {Updater ? (
              <UpdatedBy updater={Updater} updateDate={UpdateAt} />
            ) : (
              <></>
            )}
          </SideFormContent>

          {WasDeleted ? (
            <SideFormFooter
              showFooterAnyway
              canDelete={true}
              hideSubmit={true}
              deleteLoading={deleteLoading}
              handleDelete={remove}
              subComponent={SubcompomentForRecover}
            >
              {/* <SideMenuFormFooterBase
                className={classnames(
                  "details-form-footer d-flex justify-content-between align-items-center shadow-top"
                )}
              >
               
              </SideMenuFormFooterBase> */}
            </SideFormFooter>
          ) : (
            <SideFormFooter
              subComponent={SubcompomentForConvert}
              isLoading={loading || convertLoading || deleteLoading}
            />
          )}
        </SideForm>
      </BaseSidebarContent>
    </BaseSidebarContainer>
  );
};

const RecoverButton = ({
  refetchCalendar,
  selectedUser,
  entityId,
  refetchRef,
}) => {
  const [recover, { loading: recoverLoading }] = useSidebarSpacePost(
    `calendars/${selectedUser}/${entityId}/Recover`,
    spaceAgendaSchema,
    {
      onSuccess: ({ openSidebar, data: newId, defineChildProps }) => {
        refetchCalendar && refetchCalendar();
      },
      onError: ({ error }) => {
        handleError(error);
      },
      refetchRef,
    },
  );

  return (
    <LoadableButton
      type="button"
      isLoading={recoverLoading}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        recover();
      }}
      className="btn-sm mr-3"
      vType="secondary-ghost"
    >
      <FormattedMessage id={"RECOVER"} />
    </LoadableButton>
  );
};

const DeleteButton = ({ remove, loadingRemove }) => {
  return (
    <LoadableButton
      isLoading={loadingRemove}
      type="button"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        remove();
      }}
      className="btn-sm fw-medium mr-3"
      vType="link-danger"
    >
      <FormattedMessage id={"DELETE"} />
    </LoadableButton>
  );
};

const ConvertToTimeButton = ({
  entityId,
  BeginDate,
  EndDate,
  Description,
  TotalPauses,
  personalPreferences,
  refetchCalendar,
  handleDelete,
}) => {
  const openForm = useEntitySummarySidebar();

  const handleClick = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      openForm({
        type: moduleTypes.interventions,
        props: {
          edit: true,
          agendaForm: {
            BeginDate: new Date(BeginDate),
            EndDate: new Date(EndDate),
            TotalPauses,
            Description,
          },
          personalPreferences,

          onSuccess: () => {
            if (entityId) {
              handleDelete && handleDelete();
            }
            if (refetchCalendar) refetchCalendar();
          },
        },
        options: {
          replaceTab: true,
          pushOnTop: true,
        },
      });
    },
    [
      openForm,
      BeginDate,
      EndDate,
      TotalPauses,
      Description,
      personalPreferences,
      entityId,
      refetchCalendar,
      handleDelete,
    ],
  );

  return (
    <Button
      type="button"
      onClick={handleClick}
      className="btn-sm mr-3"
      vType="secondary-ghost"
    >
      <FormattedMessage
        id={entityId ? "CONVERT_TO_TIME" : "CREATE_TIME_RECORD"}
      />
    </Button>
  );
};

export default AgendaForm;
